import React, { useState, useEffect, useContext, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { MapContainer, Marker, TileLayer, Polyline } from 'react-leaflet'
import {useHistory} from 'react-router-dom'

import { originPin, dest1Pin } from '../js/markers'
import TripContext from '../contexts/TripContext'

export default function MapInfo(props) {
  const map = useRef()

  let history = useHistory()
  let tripContext = useContext(TripContext)

  useEffect(() => {
    console.log(`center: ${mapOption.center}`)
    console.log(`bounds: ${mapOption.bounds}`)
  })

  useEffect(() => {
    initMap()
  }, [])

  const [mapOption, setMapOption] = useState({
    center: [36.312776, 59.557643],
    zoom: 12,
    latLngs: [],
    bounds: [],
    acceptOrigin: false,
    acceptDest1: false,
    acceptDest2: false,
    color: { color: 'red' },
  })

  let initMap = () => {
    try {
      var p = require('@mapbox/polyline')
      var encoded = tripContext.trip.path
      var latLng = p.decode(encoded)
      // var polyline = L.polyline(latLng)
    } catch (e) {}
    var corner1 = L.latLng(latLng[0]),
      corner2 = L.latLng(latLng[latLng.length - 1]),
      mbounds = L.latLngBounds(corner1, corner2)
    setMapOption((prevOption) => ({
      ...prevOption,
      center: [latLng[latLng.length / 2]],
      latLngs: latLng,
      //   bounds: polyline.getBounds(),
      bounds: mbounds,
    }))
  }

  let getBounds = () => {
    var corner1 = L.latLng(mapOption.latLngs[0]),
      corner2 = L.latLng(mapOption.latLngs[mapOption.latLngs.length - 1]),
      bounds = L.latLngBounds(corner1, corner2)
    return bounds
  }

  let goBack=()=>{
    history.goBack()
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center w-100 vh-100"
      style={{ position: 'relative' }}
    >
      <button className="btn btn-secondary" style={{position:'absolute' ,top:'10px',left:'10px',zIndex:'10' }} onClick={goBack}>بازگشت</button>
      <MapContainer
        ref={map}
        center={mapOption.center}
        zoom={mapOption.zoom}
        bounds={getBounds()}
        scrollWheelZoom={false}
        boundsOptions={{ padding: [50, 50] }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="Map data © efspco"
        />
        <Polyline pathOptions={mapOption.color} positions={mapOption.latLngs} />
        <Marker position={mapOption.latLngs[0]} icon={originPin} />
        <Marker
          position={mapOption.latLngs[mapOption.latLngs.length - 1]}
          icon={dest1Pin}
        />
      </MapContainer>
    </div>
  )
}
